(() => {
  const init = () => {
    document.querySelectorAll('.jetpack-story video[controls]').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) video.pause();
      }), {threshold: .1}).observe(video);
    });
    document.querySelectorAll('[data-jetpack-motion]').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!video.getAttribute('src')) video.src = video.dataset.src;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }), {threshold: .1}).observe(video);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
